export const AdapterLoginStrategyType = {
    CREDENTIALS: 'credentials',
    REDIRECT: 'redirect'
}

export const AdapterLogoutStrategyType = {
    CREDENTIALS: 'credentials',
    REDIRECT: 'redirect'
}